import { render } from "./practice-people-directors.html?vue&type=template&id=03029f84&scoped=true&ts=true&external"
import script from "./practice-people-directors.ts?vue&type=script&lang=ts&external"
export * from "./practice-people-directors.ts?vue&type=script&lang=ts&external"

import "./practice-people-directors.scss?vue&type=style&index=0&id=03029f84&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03029f84"]])

export default __exports__